
import { Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { Attachment, IdValuePair, IMeterGroup, IMeterMake, IMeterRemoteReadTypeCode, IMeterSize, IMeterType, IRouteCode, LookupCriteria, Meter, MeterRead, MeterReadSearchCriteria, NewReadingValues, NumberOfDials_TypeDef, ServiceResponse } from "@tylertech/tyler-api-types";

/**
 * MeterService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class MeterService {
    constructor(private readonly $apiService: ApiService) { }
    
    GetMeter(meterId: string): Promise<Meter> {
        return this.$apiService.sendAuth("IMeterService/GetMeter", meterId);
    }
    GetMeterGroups(): Promise<IMeterGroup[]> {
        return this.$apiService.sendAuth("IMeterService/GetMeterGroups");
    }
    GetMeterMakes(): Promise<IMeterMake[]> {
        return this.$apiService.sendAuth("IMeterService/GetMeterMakes");
    }
    GetMeterReads(meterReadSearchCriteria: MeterReadSearchCriteria): Promise<MeterRead[]> {
        return this.$apiService.sendAuth("IMeterService/GetMeterReads", meterReadSearchCriteria);
    }
    GetMeterRemoteReadTypeCodes(): Promise<IMeterRemoteReadTypeCode[]> {
        return this.$apiService.sendAuth("IMeterService/GetMeterRemoteReadTypeCodes");
    }
    GetMeterSizes(): Promise<IMeterSize[]> {
        return this.$apiService.sendAuth("IMeterService/GetMeterSizes");
    }
    GetMeterTypes(): Promise<IMeterType[]> {
        return this.$apiService.sendAuth("IMeterService/GetMeterTypes");
    }
    GetNumberOfDialsTypes(): Promise<NumberOfDials_TypeDef[]> {
        return this.$apiService.sendAuth("IMeterService/GetNumberOfDialsTypes");
    }
    GetRouteCodes(): Promise<IRouteCode[]> {
        return this.$apiService.sendAuth("IMeterService/GetRouteCodes");
    }
    LookupMeter(pCriteria: LookupCriteria): Promise<IdValuePair[]> {
        return this.$apiService.sendAuth("IMeterService/LookupMeter", pCriteria);
    }
    UpdateMeter(meter: Meter): Promise<ServiceResponse> {
        return this.$apiService.sendAuth("IMeterService/UpdateMeter", meter);
    }
    UpdateMeterReading(newReadingValues: NewReadingValues): Promise<ServiceResponse> {
        return this.$apiService.sendAuth("IMeterService/UpdateMeterReading", newReadingValues);
    }
    UploadAttachmnets(pAttachment: Attachment): Promise<ServiceResponse> {
        return this.$apiService.sendAuth("IMeterService/UploadAttachmnets", pAttachment);
    }
}
